import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './newyear2026.json'; // The JSON you provided

const NewYear2026 = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="New Year resolutions, goals, and future planning vocabulary. B2 level grammar, vocabulary, and discussion exercises."
            level="B2"
            title="New Year 2026"
            image="/Images/newyear2026-2.webp"
            seoTitle="Free English Lesson Plans: New Year 2026"
            seoDescription="New Year resolutions, goals, and future planning vocabulary. B2 level grammar, vocabulary, and discussion exercises."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default NewYear2026;


